import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import useUIStore from '../store/uiStore';

// Where the separate HR Assistant (komal_hr_chatbot/) lives - set at build time for production.
const HR_ASSISTANT_URL = process.env.REACT_APP_HR_URL || 'http://localhost:3001';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, isLoading, error, clearError } = useAuthStore();
  const showToast = useUIStore((s) => s.showToast);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    const success = await login(email, password);
    if (success) {
      showToast('Logged in successfully', 'success');
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card p-8 w-full max-w-sm">
        <img src="/assets/logo-color.png" alt="Komal" className="h-12 w-auto mb-4" />
        <h1 className="text-xl font-bold text-komal-dark mb-1">Komal OS</h1>
        <p className="text-gray-500 text-sm mb-6">Sign in to your account</p>

        {error && (
          <div className="bg-red-50 text-red-700 text-sm rounded px-3 py-2 mb-4 border border-red-200">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-komal-blue"
              placeholder="you@komalwatertech.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-komal-blue"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-komal-blue hover:bg-komal-blue-dark text-white font-semibold py-2 rounded text-sm disabled:opacity-60"
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {/* Employees without a Komal OS account use the separate HR Assistant (its own
            email + OTP login) - linked here so there is one address to remember. */}
        <div className="mt-6 pt-5 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-500 mb-2">Not a Komal OS user? Check your leave, salary and company policies:</p>
          <a
            href={HR_ASSISTANT_URL}
            className="inline-block w-full border border-komal-blue text-komal-blue hover:bg-komal-blue hover:text-white font-semibold py-2 rounded text-sm"
          >
            Employee HR Assistant &rarr;
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
